import React from 'react';
import { openFranchiseFinmodelForm } from './franchiseConstants';

export function ConditionsNewSection() {
  return (
    <section id="s-conditions-new" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-conditions-new" data-reveal>
          <div className="franchise-conditions-new__banner">Условия франшизы</div>
          <div className="franchise-conditions-new__body">
            <div className="franchise-conditions-new__body__content">
              <div className="franchise-conditions-new__body__content__box">
                <span>Паушальный взнос</span>
                <div>350 000 ₽</div>
              </div>
              <div className="franchise-conditions-new__body__content__box">
                <span>Роялти</span>
                <div>4,5%</div>
              </div>
              <div className="franchise-conditions-new__body__content__box">
                <span>Окупаемость</span>
                <div>6 – 12 месяцев</div>
              </div>
              <div className="franchise-conditions-new__body__content__box">
                <span>Инвестиции</span>
                <div>1,6 – 2,8 млн. ₽</div>
              </div>
            </div>
            <div className="franchise-conditions-new__body__text">Финансовая модель рассчитывается <br /> индивидуально под ваш город</div>
            <button type="button" className="franchise-conditions-new__body__button" onClick={openFranchiseFinmodelForm()}>Получить финансовую <br /> модель</button>
            <img className="franchise-conditions-new__body__box" src="/assets/media/franchise/conditions-section/box.png" alt="Box" />
            <img className="franchise-conditions-new__body__food" src="/assets/media/franchise/conditions-section/food.png" alt="Food" />
            <img className="franchise-conditions-new__body__fish" src="/assets/media/franchise/map-section/fish.svg" alt="Рыбки" />
          </div>
        </div>
      </div>
    </section>
  );
}
